import React, { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import Icon from '../Icon'
import Button from '../Button'
import Heading from '../Heading'
import './contactform.scss'
import ContactPicker from './ContactPicker'
import { mapEdgesToNodes } from '../../utils/helpers'
import { useStaticQuery } from 'gatsby'

function encode(data) {
  const formData = new FormData()
  for (const key of Object.keys(data)) {
    formData.append(key, data[key])
  }
  return formData
}

export const ContactForm = ({
  otherClasses,
  toggleCancel,
  partnerImages,
  nodes,
}) => {
  const mappedPartnerImages = mapEdgesToNodes(partnerImages)

  const contactFormClasses = clsx(
    otherClasses,
    'max-w-[720px] bg-primary_blue_700 overflow-y-auto h-full'
  )

  const messageRef = useRef('')
  const [state, setState] = useState({
    name: '',
    phone: '',
    email: '',
    'What Can We Help You With?': '',
    description: '',
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    const form = e.target
    try {
      const response = await fetch('/', {
        method: 'POST',
        body: encode({
          'form-name': form.getAttribute('name'),
          ...state,
        }),
      })
      const { status } = response
      if (status === 200) {
        messageRef.current.innerHTML =
          'Thank you for for submission! We will get in touch with you shortly.'
        setTimeout(() => {
          messageRef.current.innerHTML = null
        }, 2000)
        setState({
          name: '',
          phone: '',
          email: '',
          'What Can We Help You With?': '',
          description: '',
        })
        form.reset()
      }
    } catch (error) {
      console.error(error)
    }
  }

  const [toggleState, setToggleState] = useState('book-meeting')
  const toggleTab = (index) => {
    setToggleState(index)
  }
  return (
    <div className={contactFormClasses} data-testid="contact-form">
      <div className="flex justify-between items-center px-6 py-4 border-b-[1px] border-b-gray-600">
        <div className="flex items-center gap-2 cursor-pointer">
          <Icon
            icon="navbar-phone-outline-icon"
            iconHeight={24}
            iconWidth={24}
          />
          <a
            href="tel:6194361826"
            className="font-Work_Sans text-xl leading-[30px] text-white font-normal  "
          >
            619-436-1826
          </a>
        </div>
        <button onClick={() => toggleCancel()}>
          <Icon icon="cancel-white-icon" iconHeight={12} iconWidth={12} />
        </button>
      </div>
      <div className="pb-10 px-4 md:px-[84px] w-full mt-8">
        <Heading
          type="h3"
          otherClasses=" font-Manrope font-light text-white  mb-8"
        >
          Let’s Get Started
        </Heading>
        <div className="w-full flex flex-row items-center">
          <button
            onClick={() => toggleTab('book-meeting')}
            className={clsx(
              'flex items-center gap-2 justify-center text-base leading-6 font-Work_Sans font-normal  w-full py-[10px] rounded-tl-full rounded-bl-full',
              toggleState === 'book-meeting'
                ? 'bg-accent_orange_600 text-black '
                : 'bg-primary_blue_800 text-gray-400'
            )}
          >
            Schedule a free consultation
          </button>
          <button
            onClick={() => toggleTab('send-message')}
            className={clsx(
              'flex items-center gap-2 justify-center text-base leading-6 font-Work_Sans font-normal  w-full py-[10px] rounded-tr-full rounded-br-full',
              toggleState === 'send-message'
                ? 'bg-accent_orange_600 text-black '
                : 'bg-primary_blue_800 text-gray-400'
            )}
          >
            Send us a message
          </button>
        </div>

        {toggleState === 'book-meeting' && (
          <div className="flex flex-col gap-y-2 mt-6">
            <p className="text-white text-sm">
              Book a complimentary 30-minute consultation with our CA Consumer
              Law APC team to discuss how we can be of service.
            </p>
            <p className="text-white text-sm">
              Please note that for Lemon Law assistance,{' '}
              <strong>your vehicle must be a 2020 year model or newer;</strong>{' '}
              anything older is not covered under the law.
            </p>
            <ContactPicker images={mappedPartnerImages} />
          </div>
        )}

        {toggleState === 'send-message' && (
          <form
            onSubmit={handleSubmit}
            name="Contact Us"
            method="post"
            action=""
            className={clsx('w-full mt-5 md:mt-8')}
          >
            <p
              className="font-Work-Sans text-accent_orange_600  text-base font-normal mb-4"
              ref={messageRef}
            ></p>

            <div className="mb-6">
              <label
                htmlFor="name"
                className="font-Work_Sans text-sm font-semibold text-white leading-5 "
              >
                Name
              </label>
              <input
                name="name"
                id="name"
                required
                type="text"
                value={state.name}
                onChange={(e) =>
                  setState((prev) => ({
                    ...prev,
                    name: e.target.value,
                  }))
                }
                className="bg-transparent text-white  w-full border-[1px] pl-4 font-Work_Sans border-gray-300 rounded-full h-12 mt-2 focus:border-primary_dark_blue_600 outline-offset-2 outline-[3px] outline-[#4B5E7A]"
              />
            </div>
            <div className="mb-6 flex flex-col md:flex-row gap-5 lg:gap-[21px]">
              <div className="w-full md:w-2/4">
                <label
                  htmlFor="phone"
                  className="font-Work_Sans text-sm font-semibold text-white leading-5 "
                >
                  Phone Number
                </label>
                <input
                  name="phone"
                  id="phone"
                  required
                  value={state.phone}
                  onChange={(e) =>
                    setState((prev) => ({
                      ...prev,
                      phone: e.target.value,
                    }))
                  }
                  type="text"
                  className="bg-transparent text-white  w-full border-[1px] pl-4 font-Work_Sans border-gray-300 rounded-full h-12 mt-2 focus:border-primary_dark_blue_600 outline-offset-2 outline-[3px] outline-[#4B5E7A]"
                />
              </div>
              <div className="w-full md:w-2/4">
                <label
                  htmlFor="email"
                  className="font-Work_Sans text-sm font-semibold text-white leading-5 "
                >
                  Email Address
                </label>
                <input
                  name="email"
                  id="email"
                  type="email"
                  value={state.email}
                  onChange={(e) =>
                    setState((prev) => ({
                      ...prev,
                      email: e.target.value,
                    }))
                  }
                  className="bg-transparent text-white  w-full border-[1px] pl-4 font-Work_Sans border-gray-300 rounded-full h-12 mt-2 focus:border-primary_dark_blue_600 outline-offset-2 outline-[3px] outline-[#4B5E7A]"
                />
              </div>
            </div>
            <div className="w-full flex flex-col gap-2 mb-6">
              <label
                htmlFor="option"
                className="font-Work_Sans text-sm font-semibold text-white leading-5 "
              >
                What Can We Help You With?
              </label>
              <select
                id="option"
                type="text"
                value={state['What Can We Help You With?']}
                onChange={(e) =>
                  setState((prev) => ({
                    ...prev,
                    'What Can We Help You With?': e.target.value,
                  }))
                }
                name="What Can We Help You With?"
                className="bg-transparent text-white  w-full border-[1px]  border-gray-300 flex justify-between px-4 h-12 items-center rounded-full  text-base font-normal font-Work_Sans focus:ring-0 focus:border-primary_dark_blue_600  focus:border-[1px] focus:outline-offset-2 focus:outline-[3px] focus:outline-[#4B5E7A]"
              >
                <option value="Lemon Law" className="text-black">
                  Lemon Law (must be 2020 model or newer)
                </option>
                <option value="Auto Fraud" className="text-black">
                  Auto Fraud
                </option>
                <option value="Consumer Fraud" className="text-black">
                  Consumer Fraud
                </option>
                <option value="Mediation" className="text-black">
                  Mediation
                </option>
                <option value="Other" className="text-black">
                  Other
                </option>
              </select>
            </div>
            <div className="w-full mb-6">
              <label
                htmlFor="description"
                className="font-Work_Sans text-sm font-semibold text-white leading-5 "
              >
                Message (optional)
              </label>
              <textarea
                type="text"
                value={state.description}
                onChange={(e) =>
                  setState((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
                name="description"
                id="description"
                cols="30"
                rows="10"
                className="bg-transparent text-white w-full border-[1px] font-Work_Sans pl-4 pt-4 border-gray-300 rounded-[20px] min-h-[136px] max-h-[136px] mt-2 focus:border-primary_dark_blue_600 outline-offset-2 outline-[3px] outline-[#4B5E7A]"
              ></textarea>
            </div>
            <Button label="Submit" />
          </form>
        )}
      </div>
    </div>
  )
}

export default ContactForm
